import ShareButton, { ShareDataWithUrl } from "../common/ShareButton";

import { Comedian } from "@/data/comedians";
import Image from "next/image";
import Link from "next/link";
import { cn } from "../common/utils";
import { getCDNImageURL } from "@/data/images";

interface Props {
  comedian: Comedian;
  shareData?: ShareDataWithUrl;
  className?: string;
}

export const ComedianLogo = ({
  comedian,
  shareData,
  className,
}: Props): JSX.Element => {
  const { slug, display_name, signature_img } = comedian;

  return (
    <div className={cn("flex flex-row justify-center mt-5", className)}>
      <Link
        href={`/${slug}`}
        title="comedian-signature"
        className={cn("flex flex-row justify-start overflow-hidden")}
      >
        {signature_img ? (
          <Image
            src={getCDNImageURL(signature_img)}
            alt={display_name as string}
            width={360}
            height={50}
            sizes="100vw"
            // note: this should be the same height as the text below
            className="w-auto h-[40px]"
          />
        ) : (
          <h3 className="text-[36px] md:text-[40px] pr-1 leading-none font-anton uppercase">
            {display_name}
          </h3>
        )}
      </Link>
      {shareData ? (
        <ShareButton location="comedian-page-header" shareData={shareData} />
      ) : (
        <div />
      )}
    </div>
  );
};
